export default "__VITE_ASSET__85a63b15__"